import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import { loadGoogleMaps } from './lib/loadGoogleMaps'
import './styles/index.css'

export const createRoot = ViteReactSSG({ routes }, () => {
  // Client-only: kick off Google Maps loading (no-op without a real key).
  loadGoogleMaps()
})
